import React from "react";
import { FormProvider } from "react-hook-form";

const Form = ({ children, form }) => {
  return (
    <FormProvider {...form}>
      <form>{children}</form>
    </FormProvider>
  );
};

export default Form;
